{
  "helloWorld": "Bonjour, le monde !",
  "clickMe": "Cliquez ici",
  "healthCheckFailed": "La vérification de l'état a échoué",
  "errors": {
    "unexpected": "Une erreur inattendue s'est produite"
  },
  "error": {
    "title": "Quelque chose s'est mal passé",
    "description": "Une erreur inattendue s'est produite. Vous pouvez réessayer ou retourner à l'accueil.",
    "tryAgain": "Réessayer",
    "goHome": "Retour à l'accueil"
  },
  "dev": {
    "errorPreview": "Aperçu de l'erreur"
  },
  "actions": {
    "label": "Actions",
    "edit": "Modifier",
    "delete": "Supprimer",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "expand": "Développer",
    "collapse": "Réduire"
  },
  "validation": {
    "tooLong": "Doit contenir {{max}} caractères ou moins",
    "tooShort": "Obligatoire",
    "invalidFormat": "Format invalide",
    "invalid": "Valeur invalide"
  },
  "nav": {
    "workspace": "Espace de travail",
    "controlCenter": "Centre de contrôle",
    "jobs": "Postes",
    "analytics": "Analytique",
    "company": "Entreprise",
    "agentCommunications": "Communications de l'agent",
    "integrations": "Intégrations",
    "suggestedCandidates": "Candidats suggérés",
    "unsolicitedApplications": "Candidatures spontanées",
    "team": "Équipe",
    "templates": "Modèles",
    "workflow": "Flux de travail",
    "settings": "Paramètres",
    "language": "Langue",
    "help": "Aide",
    "logout": "Se déconnecter",
    "administration": "Administration",
    "adminTenant": "Paramètres du locataire",
    "adminOrganizations": "Organisations",
    "adminDepartments": "Départements",
    "adminFeedback": "Retours",
    "openMenu": "Ouvrir le menu",
    "mcp": "MCP",
    "orgSettings": "Paramètres de l'organisation"
  },
  "admin": {
    "tenants": {
      "title": "Locataires",
      "newTenant": "Nouveau locataire",
      "columns": {
        "name": "Nom",
        "createdAt": "Créé le",
        "actions": "Actions"
      },
      "createDialog": {
        "title": "Créer un locataire",
        "namePlaceholder": "Acme Corp"
      },
      "editDialog": {
        "title": "Modifier le locataire"
      }
    },
    "tenant": {
      "title": "Paramètres du locataire",
      "name": "Nom du locataire",
      "save": "Enregistrer les modifications",
      "saved": "Enregistré"
    },
    "organizations": {
      "title": "Organisations",
      "newOrg": "Nouvelle organisation",
      "columns": {
        "name": "Nom",
        "slug": "Slug",
        "tenant": "Locataire",
        "createdAt": "Créé le",
        "actions": "Actions",
        "viewWorkspace": "Voir l'espace de travail"
      },
      "createDialog": {
        "title": "Créer une organisation",
        "namePlaceholder": "Acme Corp",
        "slugPlaceholder": "acme-corp",
        "newTenant": "Nouveau locataire",
        "existingTenant": "Locataire existant",
        "tenantName": "Nom du locataire",
        "tenantNamePlaceholder": "Acme Corp",
        "selectTenant": "Sélectionner un locataire"
      },
      "editDialog": {
        "title": "Modifier l'organisation",
        "language": "Langue",
        "languagePlaceholder": "Sélectionner une langue"
      },
      "deleteConfirm": {
        "title": "Supprimer l'organisation",
        "description": "Cela supprimera également tous les départements de cette organisation. Cette action est irréversible.",
        "confirm": "Supprimer",
        "cancel": "Annuler"
      }
    },
    "departments": {
      "title": "Départements",
      "newDept": "Nouveau département",
      "columns": {
        "name": "Nom",
        "slug": "Slug",
        "createdAt": "Créé le",
        "actions": "Actions"
      },
      "createDialog": {
        "title": "Créer un département",
        "namePlaceholder": "Ingénierie",
        "slugPlaceholder": "ingenierie"
      },
      "editDialog": {
        "title": "Modifier le département"
      },
      "deleteConfirm": {
        "title": "Supprimer le département",
        "description": "Cette action est irréversible.",
        "confirm": "Supprimer",
        "cancel": "Annuler"
      }
    },
    "viewingOrg": {
      "banner": "Affichage : {{name}}",
      "leave": "Quitter"
    },
    "feedback": {
      "title": "Retours",
      "columns": {
        "rating": "Évaluation",
        "modality": "Type",
        "candidate": "Candidat",
        "job": "Poste",
        "org": "Organisation",
        "notes": "Notes",
        "date": "Date"
      },
      "modality": {
        "voice": "Voix",
        "text": "Chat"
      },
      "thumbs": {
        "up": "Positif",
        "down": "Négatif"
      },
      "filter": {
        "all": "Tous",
        "up": "Positif",
        "down": "Négatif",
        "hasNotes": "Avec commentaires"
      },
      "stats": {
        "title": "Taux négatif",
        "period": "7 derniers jours",
        "wowUp": "+{{delta}}pp",
        "wowDown": "-{{delta}}pp",
        "wowFlat": "Aucun changement",
        "wowNoPrev": "Pas de données préc.",
        "noData": "Aucune donnée"
      },
      "noFeedback": "Aucun retour pour le moment",
      "noNotes": "Aucun commentaire écrit"
    }
  },
  "team": {
    "title": "Équipe",
    "invite": "Inviter des collègues",
    "search": "Rechercher par nom, e-mail, département...",
    "department": "Département",
    "roles": {
      "admin": "Administrateur",
      "org_manager": "Responsable d'organisation",
      "dept_manager": "Responsable de département",
      "user": "Utilisateur"
    },
    "columns": {
      "name": "Nom",
      "email": "E-mail",
      "role": "Rôle",
      "actions": "Actions"
    },
    "inviteDialog": {
      "title": "Inviter un collègue",
      "name": "Nom",
      "namePlaceholder": "Jean Dupont",
      "email": "Adresse e-mail",
      "emailPlaceholder": "collègue@entreprise.fr",
      "role": "Rôle",
      "departments": "Départements",
      "submit": "Envoyer l'invitation"
    },
    "actions": {
      "changeRole": "Changer le rôle",
      "addDepartment": "Ajouter à un département",
      "removeDepartment": "Retirer du département",
      "removeFromOrg": "Retirer de l'organisation"
    },
    "noResults": "Aucun résultat trouvé.",
    "noMembers": "Aucun membre d'équipe pour le moment."
  },
  "jobs": {
    "title": "Postes",
    "backToJobs": "Postes",
    "newJob": "Nouveau poste",
    "createNewJob": "Créer un nouveau poste",
    "importFromAts": "Importer depuis {{atsName}}",
    "searchPlaceholder": "Rechercher des postes...",
    "completedPlaceholder": "{{completed}} sur {{total}} terminés",
    "tabs": {
      "active": "Actifs",
      "archived": "Archivés"
    },
    "columns": {
      "name": "Nom",
      "createdBy": "Créé par",
      "createdAt": "Créé le",
      "actions": "Actions"
    },
    "empty": "Aucun poste trouvé.",
    "emptyTitle": "Aucun poste pour le moment",
    "emptyDescription": "Créez votre premier poste ou importez depuis votre ATS pour commencer.",
    "emptyArchivedTitle": "Aucun poste archivé",
    "emptyArchivedDescription": "Les postes archivés apparaîtront ici.",
    "emptySearchDescription": "Aucun poste ne correspond à votre recherche.",
    "actions": {
      "archive": "Archiver",
      "archiveConfirmTitle": "Archiver le poste",
      "archiveConfirmDescription": "Êtes-vous sûr de vouloir archiver ce poste ? Il sera déplacé vers l'onglet Archivés.",
      "archiveSuccess": "Poste archivé",
      "archiveError": "Impossible d'archiver le poste. Veuillez réessayer."
    },
    "createError": "Échec de la création du poste. Veuillez réessayer.",
    "status": {
      "active": "Actif",
      "archived": "Archivé"
    },
    "setupStatus": {
      "draft": "Brouillon",
      "questions_pending": "Configuration requise",
      "ready": "Prêt",
      "active": "Actif"
    },
    "applicantSync": {
      "syncingBanner": "Récupération des candidats depuis {{provider}}...",
      "failedBanner": "La synchronisation des candidats a échoué",
      "adminActions": "Actions administrateur",
      "resyncLabel": "Synchroniser les candidats maintenant",
      "lastSyncedAt": "Dernière synchronisation : {{date}}",
      "addDemoApplicant": "Ajouter un candidat de démonstration"
    },
    "detail": {
      "tabs": {
        "candidates": "Candidats",
        "results": "Résultats",
        "settings": "Paramètres"
      },
      "info": {
        "title": "Informations sur le poste",
        "employer": "Employeur",
        "location": "Lieu",
        "description": "Description",
        "modality": "Modalité d'entretien",
        "languages": "Langues",
        "atsProvider": "Fournisseur ATS",
        "atsId": "ID du poste ATS",
        "noDescription": "Aucune description fournie."
      },
      "questions": {
        "title": "Questions d'entretien",
        "empty": "Aucune question configurée pour ce poste.",
        "optional": "Facultatif",
        "categories": {
          "eligibility": "Éligibilité",
          "nice_to_have": "Atouts",
          "job_preview": "Attentes du poste",
          "assessment": "Évaluation",
          "information": "Information"
        }
      }
    }
  },
  "wizard": {
    "step": "Étape {{current}} sur {{total}}",
    "back": "Retour",
    "next": "Continuer",
    "goLive": "Mettre en ligne",
    "saveAndContinue": "Enregistrer et continuer",
    "manual": {
      "title": "Nouveau poste",
      "step1Title": "Informations de base",
      "step2Title": "Questions d'entretien",
      "step3Title": "Confirmer et mettre en ligne"
    },
    "import": {
      "title": "Importer depuis ATS",
      "step0Title": "Sélectionner les postes",
      "step1Title": "Associer les étapes",
      "step2Title": "Paramètres d'entretien",
      "step3Title": "Questions d'entretien",
      "step4Title": "Confirmer et mettre en ligne"
    },
    "stageSelector": {
      "title": "Associer les étapes du pipeline",
      "description": "Sélectionnez quelle étape de chaque poste correspond à chaque action Kiku. Pré-rempli lorsque les noms d'étapes correspondent à vos valeurs par défaut.",
      "continue": "Continuer",
      "loading": "Chargement des étapes…"
    },
    "basicInfo": {
      "title": "Titre du poste",
      "titlePlaceholder": "ex. Ingénieur logiciel senior",
      "description": "Description du poste",
      "descriptionPlaceholder": "Décrivez le rôle, les responsabilités et les exigences...",
      "descriptionHint": "Utilisé par l'IA pour générer des questions d'entretien pertinentes",
      "employer": "Nom de l'employeur (facultatif)",
      "employerPlaceholder": "ex. Acme Corp",
      "modality": "Format d'entretien",
      "modalityText": "Chat textuel",
      "modalityTextDesc": "Le candidat tape ses réponses dans une interface de chat",
      "modalityVoice": "Entretien vocal",
      "modalityVoiceDesc": "Entretien audio en direct dans une salle de réunion virtuelle",
      "languages": "Langue(s) d'entretien",
      "languagesHint": "Sélectionnez au moins une langue",
      "languagesSearch": "Rechercher des langues…",
      "languagesEmpty": "Aucune langue trouvée.",
      "modalityRequired": "Sélectionnez au moins un format d'entretien",
      "languagesRequired": "Sélectionnez au moins une langue"
    },
    "atsSelector": {
      "title": "Sélectionner les postes à importer",
      "search": "Rechercher des postes...",
      "selectAll": "Tout sélectionner",
      "selected": "{{count}} sélectionné(s)",
      "noJobs": "Aucun poste actif trouvé dans votre ATS",
      "noDescription": "Aucune description disponible — l'IA générera à partir du titre uniquement",
      "continue": "Continuer avec {{count}} poste(s)"
    },
    "sharedSettings": {
      "title": "Paramètres d'entretien",
      "subtitle": "Ces paramètres s'appliqueront à tous les postes importés",
      "employer": "Nom de l'employeur",
      "employerPlaceholder": "p.ex. Acme Corp"
    },
    "questions": {
      "title": "Questions d'entretien",
      "generateError": "Échec de la génération des questions. Veuillez réessayer.",
      "retry": "Réessayer",
      "generating": "Préparation des questions pour trouver les meilleurs candidats…",
      "generatingHint": "Cela prend généralement quelques secondes",
      "addQuestion": "Ajouter une question",
      "categories": {
        "eligibility": "Éligibilité",
        "nice_to_have": "Atouts",
        "job_preview": "Aperçu réaliste du poste",
        "assessment": "Évaluation",
        "information": "Collecte d'informations"
      },
      "categoryDescriptions": {
        "eligibility": "Questions oui/non sur les exigences obligatoires",
        "nice_to_have": "Questions oui/non sur les qualifications souhaitables mais non requises",
        "job_preview": "Met en avant un aspect exigeant du poste. Permet de s'assurer que le candidat comprend ce que le rôle implique et prévient le désengagement ultérieur",
        "assessment": "Questions comportementales et de compétences",
        "information": "Questions pour recueillir du contexte — non utilisées dans la notation"
      },
      "categoryPurpose": {
        "eligibility": "Réussite ou échec",
        "job_preview": "Réussite ou échec",

        "assessment": "Noté",
        "information": "Pour information uniquement"
      },
      "optional": "Facultatif",
      "competency": "Compétence",
      "scoringExamples": "Ancres de notation",
      "editScoringExamples": "Modifier les ancres de notation",
      "regenerateScoringExamples": "Régénérer les ancres de notation",
      "dontRegenerateScoringExamples": "Ne pas régénérer les ancres de notation",
      "regeneratingScoringExamples": "Régénération en cours...",
      "regenerateScoringError": "Échec de la régénération des ancres de notation",
      "score1": "Score 1 — Insuffisant",
      "score3": "Score 3 — Satisfaisant",
      "score5": "Score 5 — Excellent",
      "aiGenerated": "Généré par l'IA"
    },
    "confirm": {
      "title": "Prêt à mettre en ligne",
      "jobsCount": "{{count}} poste(s) seront activé(s)",
      "questionsCount": "{{count}} question(s) d'entretien",
      "modality": "Format",
      "languages": "Langues",
      "goLiveHint": "Les candidats pourront commencer les entretiens immédiatement après l'activation."
    }
  },
  "login": {
    "title": "Se connecter à Kiku",
    "subtitle": "Gérez votre pipeline de recrutement.",
    "cta": "Se connecter",
    "waitingForLogin": "En attente de la connexion…",
    "disclosure": "Vous interagissez avec un système d'IA. Kiku utilise l'IA pour assister le recrutement — toutes les décisions sont soumises à une vérification humaine.",
    "errors": {
      "not_provisioned": "Votre compte n'est pas encore configuré. Contactez votre administrateur.",
      "missing_code": "L'authentification a échoué. Veuillez réessayer.",
      "session_expired": "Votre session a expiré. Veuillez vous reconnecter."
    }
  },
  "settings": {
    "profile": {
      "title": "Profil",
      "name": "Nom",
      "email": "E-mail",
      "role": "Rôle",
      "departments": "Départements"
    }
  },
  "integrations": {
    "title": "Intégrations",
    "ats": {
      "title": "Connexion ATS",
      "description": "Connectez votre système de suivi des candidatures pour synchroniser les postes et gérer les étapes des candidats.",
      "provider": "Fournisseur",
      "apiKey": "Clé API",
      "apiKeyPlaceholder": "Entrez votre clé API",
      "apiKeySet": "Clé enregistrée — entrez une nouvelle valeur pour la remplacer",
      "save": "Enregistrer la connexion",
      "verify": "Vérifier la connexion",
      "verifyStatus": {
        "valid": "Connecté",
        "invalid": "Clé invalide",
        "error": "La vérification a échoué",
        "idle": "Non vérifié",
        "loading": "Vérification en cours..."
      },
      "providers": {
        "teamtailor": "Teamtailor",
        "recman": "RecMan",
        "logicmelon": "LogicMelon",
        "teamtailorDescription": "Teamtailor est une plateforme de recrutement qui aide les entreprises à attirer, développer et recruter les meilleurs candidats.",
        "recmanDescription": "RecMan est un système de recrutement pour les agences de travail temporaire et de recrutement sur le marché nordique.",
        "logicmelonDescription": "LogicMelon est un ATS multi-diffusion pour le recrutement à haut volume, populaire dans le secteur de l'éducation au Royaume-Uni."
      }
    },
    "stageMapping": {
      "title": "Association des étapes",
      "description": "Associez les étapes de votre ATS aux étapes du flux de travail Kiku.",
      "initialStage": "Étape initiale",
      "passInterviewStage": "Entretien réussi",
      "failInterviewStage": "Entretien échoué",
      "recommendedStage": "Recommandé",
      "selectStage": "Sélectionner une étape",
      "save": "Enregistrer l'association"
    },
    "errors": {
      "notConfigured": "Aucun ATS configuré. Enregistrez d'abord votre connexion.",
      "fetchStagesFailed": "Impossible de charger les étapes depuis votre ATS.",
      "saveFailed": "Échec de l'enregistrement de la configuration."
    }
  },
  "applications": {
    "title": "Candidatures",
    "newCandidate": "Nouveau candidat",
    "addCandidate": "Ajouter un nouveau candidat",
    "importFromCsv": "Importer depuis CSV",
    "importDialog": {
      "title": "Importer des candidats",
      "back": "Retour",
      "next": "Suivant",
      "upload": {
        "hint": "Glissez-déposez un fichier CSV ici, ou cliquez pour parcourir",
        "csvOnly": "Fichiers CSV uniquement",
        "browse": "Parcourir"
      },
      "mapping": {
        "headerRow": "La première ligne est un en-tête",
        "nameColumn": "Colonne nom",
        "emailColumn": "Colonne e-mail",
        "phoneColumn": "Colonne téléphone",
        "notMapped": "— non associé —",
        "column": "Colonne",
        "preview": "Aperçu"
      },
      "review": {
        "allValid": "Les {{count}} candidats sont valides",
        "summary": "{{valid}} valides · {{invalid}} invalides",
        "skipInvalid": "Ignorer les lignes invalides et importer {{count}} candidats valides",
        "recheck": "Revérifier",
        "import": "Importer {{count}} candidats",
        "colName": "Nom",
        "colEmail": "E-mail",
        "colPhone": "Téléphone",
        "colStatus": "Statut"
      },
      "errors": {
        "nameRequired": "Obligatoire",
        "emailInvalid": "E-mail invalide",
        "emailDuplicate": "E-mail en double dans ce fichier",
        "phoneInvalid": "Indicatif pays requis (ex. +33…)"
      },
      "success": {
        "title": "Importation terminée",
        "body": "{{created}} importé(s), {{conflict}} avaient déjà des candidatures (ignorés), {{error}} échoué(s).",
        "done": "Terminé"
      }
    },
    "screening": "Présélection",
    "aiRanked": "Classé par l'IA",
    "emptyStage": "Aucune candidature",
    "emptyTitle": "Aucun candidat pour le moment",
    "emptyDescription": "Ajoutez votre premier candidat pour commencer à examiner les candidatures.",
    "emptySearchDescription": "Aucun candidat ne correspond à votre recherche.",
    "searchPlaceholder": "Rechercher par nom, e-mail ou téléphone",
    "createDialog": {
      "title": "Ajouter une candidature",
      "name": "Nom complet",
      "namePlaceholder": "ex. Jean Dupont",
      "email": "Adresse e-mail",
      "emailPlaceholder": "ex. jean@exemple.com",
      "phoneNumber": "Numéro de téléphone",
      "phoneNumberPlaceholder": "ex. 01 23 45 67 89",
      "phoneCountryCode": "Indicatif pays",
      "phoneCountryCodePlaceholder": "ex. +33",
      "submit": "Créer la candidature"
    },
    "errors": {
      "conflict": "Ce candidat a déjà une candidature pour ce poste."
    },
    "detail": {
      "title": "Détails de la candidature",
      "tabs": {
        "application": "Candidature",
        "profile": "Profil",
        "activity": "Activité"
      },
      "stage": "Étape",
      "interviewLink": "Lien d'entretien",
      "interviewStatus": "Statut de l'entretien",
      "copyLink": "Copier le lien",
      "linkCopied": "Copié !",
      "noInterview": "Aucune session d'entretien trouvée",
      "noResults": {
        "title": "Entretien non complété",
        "description": "Ce candidat n'a pas encore passé l'entretien. Partagez le lien d'entretien pour commencer."
      },
      "inProgress": {
        "title": "Entretien en cours",
        "description": "Ce candidat a commencé l'entretien. Les résultats apparaîtront ici une fois terminé."
      },
      "openInterview": "Ouvrir l'entretien",
      "commChannel": {
        "label": "Envoyer via",
        "manual": "Manuel",
        "email": "E-mail",
        "sms": "SMS",
        "whatsapp": "WhatsApp"
      },
      "status": {
        "pending": "En attente",
        "in_progress": "En cours",
        "completed": "Terminé",
        "expired": "Expiré"
      }
    }
  },
  "pagination": {
    "rowsPerPage": "Lignes par page",
    "rowsSelected": "{{count}} sur {{total}} ligne(s) sélectionnée(s).",
    "pageOf": "Page {{page}} sur {{total}}",
    "previous": "Précédent",
    "next": "Suivant"
  },
  "screening": {
    "title": "Entretien de présélection",
    "aiDisclosure": "Vous discutez avec Sara, une assistante de recrutement par IA",
    "selectLanguage": "Sélectionnez votre langue préférée",
    "selectLanguageDescription": "L'entretien se déroulera dans la langue que vous choisissez",
    "startInterview": "Commencer l'entretien",
    "previewJobTitle": "Poste exemple — Entreprise exemple",
    "typeMessage": "Tapez votre message...",
    "send": "Envoyer",
    "typing": "Sara est en train d'écrire...",
    "submitInterview": "Soumettre l'entretien",
    "loading": "Chargement de l'entretien...",
    "completed": {
      "title": "Entretien terminé",
      "submitted": "Entretien soumis avec succès",
      "message": "Merci d'avoir complété l'entretien pour {{jobTitle}}. Un recruteur examinera vos réponses et vous contactera."
    },
    "expired": {
      "title": "Entretien expiré",
      "message": "Ce lien d'entretien a expiré. Veuillez contacter le recruteur pour une nouvelle invitation."
    },
    "notFound": {
      "title": "Entretien introuvable",
      "message": "Ce lien d'entretien n'est pas valide. Veuillez vérifier le lien et réessayer."
    },
    "feedback": {
      "helpUsImprove": "Aidez-nous à nous améliorer",
      "teaser": "Comment s'est passée l'expérience d'entretien ?",
      "overallPrompt": "Comment évaluez-vous l'expérience globale de l'entretien ?",
      "disclaimer": "Nous aimerions avoir votre avis — c'est anonyme et n'affectera pas votre candidature.",
      "prompt": "Comment s'est passé l'entretien ?",
      "good": "Bien",
      "bad": "Mauvais",
      "notesLabel": "Des commentaires supplémentaires ?",
      "notesPlaceholder": "Dites-nous en plus (facultatif)...",
      "skip": "Passer",
      "submit": "Soumettre le retour",
      "submitError": "Échec de la soumission du retour. Veuillez réessayer."
    },
    "technicalIssue": {
      "buttonLabel": "Problème technique ?",
      "modalTitle": "Signaler un problème technique",
      "modalDescription": "Décrivez le problème rencontré. Votre retour sera envoyé et l'entretien redémarrera.",
      "notesLabel": "Que s'est-il passé ?",
      "notesPlaceholder": "ex. La page s'est figée et j'ai perdu ma progression...",
      "submitButton": "Envoyer le retour et redémarrer",
      "submitError": "Échec de l'envoi. Veuillez réessayer.",
      "cancel": "Annuler"
    },
    "error": {
      "title": "Quelque chose s'est mal passé",
      "message": "Une erreur s'est produite. Veuillez réessayer plus tard.",
      "sendFailed": "Échec de l'envoi du message. Veuillez réessayer."
    },
    "languages": {
      "en": "Anglais",
      "da": "Danois",
      "sv": "Suédois",
      "de": "Allemand",
      "fr": "Français",
      "es": "Espagnol",
      "nl": "Néerlandais",
      "pl": "Polonais",
      "fi": "Finnois",
      "ro": "Roumain"
    },
    "landing": {
      "badge": "ENTRETIEN D'EMBAUCHE",
      "greeting": "Bonjour {{name}} ! Nous sommes ravis de vous voir ici. Ceci est une invitation pour un rapide entretien de présélection en ligne avec une IA afin de mieux vous connaître. Passez-le quand vous êtes prêt(e).",
      "startChat": "Commencer l'entretien par chat",
      "startVoice": "Commencer l'entretien vocal",
      "or": "ou",
      "minutes": "{{count}} minutes",
      "questions": "{{count}} questions"
    },
    "modality": {
      "title": "Choisissez le format d'entretien",
      "description": "Sélectionnez comment vous souhaitez passer l'entretien",
      "text": "Entretien textuel",
      "textDescription": "Tapez vos réponses dans un chat",
      "voice": "Entretien vocal",
      "voiceDescription": "Donnez vos réponses à voix haute"
    },
    "deviceTest": {
      "title": "Vérifiez votre audio",
      "description": "Assurez-vous que votre microphone et vos haut-parleurs fonctionnent avant de commencer",
      "microphone": "Microphone",
      "speakers": "Haut-parleurs",
      "testMicrophone": "Autoriser l'accès au microphone",
      "testSpeakers": "Jouer un son de test",
      "playAgain": "Rejouer",
      "requestingPermission": "Demande d'autorisation...",
      "microphoneDenied": "L'accès au microphone a été refusé. Veuillez autoriser l'accès dans les paramètres de votre navigateur.",
      "confirm": "Tout fonctionne — commencer l'entretien"
    },
    "voice": {
      "title": "Entretien vocal",
      "connecting": "Connexion...",
      "recording": "Enregistrement",
      "interviewInProgress": "Entretien en cours",
      "inProgress": "Entretien en cours — parlez naturellement",
      "muted": "Votre microphone est coupé",
      "finished": "Entretien terminé — merci !",
      "alreadyInProgress": "Entretien en cours",
      "alreadyInProgressMessage": "Votre entretien vocal est actuellement actif. Le redémarrer annulera la session en cours — ne faites cela que si vous n'êtes plus connecté.",
      "retryButton": "Redémarrer l'entretien"
    }
  },
  "scoring": {
    "title": "Résultats d'entretien",
    "pending": "Notation en cours...",
    "processing": "L'IA évalue l'entretien...",
    "failed": "La notation a échoué",
    "overallScore": "Score global",
    "overallScoreTooltip": "Score de 0 à 100 basé sur la moyenne de toutes les questions d'évaluation, ajusté pour l'éligibilité et les attentes du poste.",
    "outcome": "Résultat",
    "outcomes": {
      "pass": "Réussi",
      "fail": "Échoué"
    },
    "summary": "Résumé",
    "eligibility": "Éligibilité",
    "niceToHave": "Atouts",
    "expectations": "Attentes du poste",
    "assessment": "Évaluation",
    "information": "Collecte d'informations",
    "scoringAnchors": "Ancres de notation",
    "candidateAnswer": "Réponse du candidat",
    "transcript": "Transcription de l'entretien",
    "viewInTranscript": "Voir dans la transcription",
    "copyPasteDetected": "Réponse copiée-collée",
    "copyPasteWarning": "Copier-coller détecté dans cet entretien",
    "copyPasteWarningTooltip": "Une ou plusieurs réponses du candidat ont été collées pendant l'entretien. Cela peut indiquer que le candidat a utilisé des réponses pré-rédigées.",
    "verdicts": {
      "pass": "Réussi",
      "fail": "Échoué",
      "unsure": "Incertain",
      "review": "À vérifier"
    },
    "optional": "Facultatif",
    "averageScore": "Score moyen des questions",
    "reasoning": "Raisonnement",
    "evidence": "Preuves",
    "backToJob": "Retour au poste",
    "overrideDialog": {
      "title": "Modifier le score",
      "titleVerdict": "Modifier le verdict",
      "currentValue": "Valeur actuelle",
      "newValue": "Nouvelle valeur",
      "reason": "Raison de la modification",
      "reasonPlaceholder": "Expliquez pourquoi vous modifiez ce score...",
      "reasonMinLength": "Minimum {{min}} caractères requis",
      "save": "Enregistrer la modification",
      "cancel": "Annuler",
      "error": "Échec de l'enregistrement de la modification. Veuillez réessayer."
    }
  },
  "workflows": {
    "title": "Flux de travail",
    "description": "Configurez les étapes que les candidatures traversent pendant votre processus de recrutement.",
    "stages": {
      "title": "Étapes du pipeline",
      "subtitle": "Glissez pour réordonner. Les candidatures progressent à travers ces étapes de haut en bas.",
      "system": "Système",
      "manage": "Gérer les étapes",
      "addStage": "Ajouter une étape",
      "editStage": "Modifier l'étape",
      "deleteStage": "Supprimer l'étape",
      "stageName": "Nom de l'étape",
      "stageNamePlaceholder": "ex. Entretien téléphonique",
      "stageColor": "Couleur",
      "deleteConfirm": "Supprimer cette étape ? Les candidatures à cette étape doivent d'abord être déplacées.",
      "systemProtected": "Les étapes système ne peuvent pas être supprimées",
      "hasApplications": "Cette étape contient encore des candidatures assignées"
    }
  },
  "communications": {
    "title": "Communications de l'agent",
    "languageSelector": "Langue",
    "tabs": {
      "sms": "SMS",
      "email": "E-mail"
    },
    "emailSubject": "Objet",
    "emailBody": "Corps",
    "variables": {
      "applicantName": "Nom du candidat",
      "jobTitle": "Titre du poste",
      "jobEmployer": "Employeur du poste",
      "jobLocation": "Lieu du poste",
      "jobDescription": "Description du poste",
      "recruiterName": "Nom du recruteur",
      "inviteUrl": "URL d'invitation"
    },
    "actions": {
      "edit": "Modifier",
      "save": "Enregistrer les modifications",
      "reset": "Réinitialiser par défaut",
      "saved": "Modèle enregistré",
      "resetDone": "Rétabli par défaut"
    },
    "nodes": {
      "interviewIntro": "Introduction d'entretien",
      "interviewOutro": "Conclusion d'entretien",
      "reminderToFinish": "Rappel de complétion",
      "voiceAndChat": "Voix et chat",
      "emailsAndSms": "E-mails et SMS",
      "comingSoon": "Bientôt disponible"
    },
    "characters": "{{count}}/{{max}} Caractères",
    "smsSegments": "{{count}} messages SMS ({{size}} car./segment)",
    "smsUnicodeWarning": "Ce message contient des emojis ou des caractères spéciaux nécessitant un encodage Unicode, réduisant la limite à 67 caractères par SMS.",
    "invite": {
      "title": "Invitation du candidat",
      "description": "Les candidats reçoivent ce message lorsqu'ils sont ajoutés à une offre d'emploi. L'e-mail inclut automatiquement un lien vers l'entretien.",
      "email": {
        "subject": "Vous êtes invité(e) à votre entretien pour {{jobTitle}} ! 🎯",
        "body": "<p>Bonjour {{applicantName}},</p><p>Vous avez été invité(e) à passer un rapide entretien de présélection en ligne avec notre intervieweur IA pour le poste de <strong>{{jobTitle}}</strong> chez <strong>{{jobEmployer}}</strong>.</p><p>C'est un moyen simple pour nous de mieux vous connaître — passez-le quand vous le souhaitez, où que vous soyez. Cela ne prend que quelques minutes !</p><p><a href=\"{{inviteUrl}}\">Commencer l'entretien</a></p><p>Bonne chance !<br>{{jobEmployer}}</p>"
      },
      "sms": "Bonjour {{applicantName}}, je suis Sara, l'assistante IA de {{jobEmployer}}. Vous êtes invité(e) à un entretien pour {{jobTitle}}. Cela ne prend que quelques minutes : {{inviteUrl}} (Pas de réponse)"
    },
    "reminder": {
      "title": "Rappel d'entretien",
      "description": "Envoyé automatiquement si un candidat n'a pas commencé son entretien dans les 24 heures suivant la réception de l'invitation.",
      "email": {
        "subject": "N'oubliez pas votre entretien pour {{jobTitle}}",
        "body": "<p>Bonjour {{applicantName}},</p><p>Nous avons remarqué que vous n'avez pas encore complété votre entretien de présélection par IA pour le poste de <strong>{{jobTitle}}</strong> chez <strong>{{jobEmployer}}</strong>.</p><p>C'est votre chance de progresser d'un pas — cela ne prend que quelques minutes, et le compléter augmentera vos chances de passer à l'étape suivante.</p><p><a href=\"{{inviteUrl}}\">Compléter l'entretien maintenant</a></p><p>Cordialement,<br>{{jobEmployer}}</p>"
      },
      "sms": "Bonjour {{applicantName}}, juste un petit rappel — vous n'avez pas encore complété votre entretien pour {{jobTitle}} chez {{jobEmployer}}. Cela ne prend que quelques minutes et augmente vos chances : {{inviteUrl}} — Sara"
    },
    "emailBodyPlaceholder": "Rédigez votre e-mail...",
    "preview": {
      "outroSampleIntro": "C'est tout — merci pour vos réponses !",
      "outroSampleAnswer": "Pas de problème, avec plaisir."
    },
    "intro": {
      "title": "Introduction d'entretien",
      "description": "Le message d'ouverture exact que Sara dira pour accueillir le candidat et demander s'il est prêt à commencer.",
      "scriptLabel": "Message d'introduction",
      "scriptPlaceholder": "Rédigez le message d'ouverture exact que Sara doit dire...",
      "defaultScript": "Bonjour ! Je suis Sara, une assistante de recrutement par IA pour {{jobEmployer}}. Merci de prendre le temps de passer l'entretien pour le poste de {{jobTitle}} — cela ne prendra que quelques minutes. Êtes-vous prêt(e) à commencer ? 😊"
    },
    "outro": {
      "title": "Conclusion d'entretien",
      "description": "Le message de clôture exact que Sara dira après que toutes les questions ont été répondues.",
      "scriptLabel": "Message de conclusion",
      "scriptPlaceholder": "Rédigez le message de clôture exact que Sara doit dire...",
      "defaultScript": "C'est tout — merci beaucoup pour votre temps aujourd'hui ! Un recruteur examinera vos réponses et vous contactera. Bonne chance ! 🙂"
    }
  },
  "activity": {
    "title": "Activité",
    "stageChange": "Déplacé de {{from}} à {{to}}",
    "interviewCompleted": "Entretien de présélection terminé",
    "scoreReceived": "Score reçu : {{score}}/100",
    "applicationCreated": "Candidature créée",
    "noteAdded": "Note ajoutée",
    "bySystem": "Système",
    "byAi": "IA",
    "empty": "Aucune activité pour le moment",
    "emptyTitle": "Aucune activité pour le moment",
    "emptyDescription": "Les actions et événements pour ce candidat apparaîtront ici."
  },
  "atsPush": {
    "title": "Statut de l'envoi ATS",
    "retry": "Réessayer l'envoi ATS",
    "retrying": "Nouvelle tentative...",
    "rerunStep": "Relancer cette étape",
    "rerunConfirm": "Cette étape a déjà été complétée avec succès. La relancer peut créer des données en double dans votre ATS. Continuer ?",
    "steps": {
      "transcript": "Transcription",
      "stage_move": "Changement d'étape"
    },
    "status": {
      "completed": "Envoyé",
      "failed": "Échoué",
      "pending": "En attente"
    },
    "note": {
      "title": "Entretien de présélection par IA",
      "outcome": "Résultat",
      "score": "Score",
      "summary": "Résumé",
      "eligibility": "Éligibilité",
      "assessment": "Évaluation",
      "transcript": "Transcription",
      "candidate": "Candidat",
      "interviewer": "Intervieweur",
      "pass": "Réussi",
      "fail": "Échoué",
      "review": "À vérifier",
      "shortlist": "Présélectionner",
      "reject": "Rejeter",
      "viewProfile": "Voir le profil du candidat dans Kiku",
      "transcriptAndAssessment": "TRANSCRIPTION ET ÉVALUATION",
      "intro": "Introduction",
      "eligibilityQuestions": "Questions d'éligibilité",
      "jobExpectations": "Attentes du poste",
      "assessmentQuestions": "Questions d'évaluation",
      "outro": "Conclusion",
      "assessmentExplanation": "EXPLICATION DE L'ÉVALUATION",
      "unsure": "Incertain",
      "viewInKiku": "VOIR DANS KIKU POUR PLUS DE DÉTAILS",
      "viewProfileLink": "Voir le profil du candidat dans Kiku pour consulter les explications des scores"
    }
  },
  "topbar": {
    "whatsNew": "Nouveautés",
    "help": "Aide",
    "notifications": "Notifications"
  },
  "extension_candidate_banner": {
    "description": "Voir les détails du candidat.",
    "description_with_transcript": "Voir la transcription de présélection et les détails du candidat.",
    "open_in_kiku": "Ouvrir",
    "dismiss": "Fermer"
  },
  "languages": {
    "en": "Anglais",
    "da": "Danois",
    "sv": "Suédois",
    "de": "Allemand",
    "fr": "Français",
    "es": "Espagnol",
    "nl": "Néerlandais",
    "pl": "Polonais",
    "fi": "Finnois",
    "ro": "Roumain"
  },
  "environmentBanner": {
    "development": "Développement",
    "test": "Test"
  },
  "notFound": {
    "title": "Page introuvable",
    "description": "La page que vous recherchez n'existe pas ou a été déplacée.",
    "goHome": "Retourner à Kiku"
  },
  "candidateProfile": {
    "title": "Candidats",
    "cv": {
      "title": "CV",
      "upload": "Télécharger un CV",
      "replace": "Remplacer le CV",
      "uploadDescription": "Téléchargez un CV pour extraire les données de profil structurées",
      "uploadLimit": "Max 10 Mo — PDF, DOCX, PNG, JPG, WEBP",
      "viewOriginal": "Voir le CV original",
      "status": {
        "pending": "En file d'attente",
        "processing": "Traitement en cours...",
        "done": "Traité",
        "failed": "Le traitement a échoué"
      },
      "parsed": {
        "title": "Profil extrait",
        "skills": "Compétences",
        "experience": "Expérience",
        "education": "Formation",
        "languages": "Langues",
        "certifications": "Certifications",
        "present": "Présent"
      },
      "errors": {
        "unsupportedType": "Type de fichier non pris en charge. Veuillez télécharger un PDF, DOCX, PNG, JPG ou WEBP.",
        "tooLarge": "Fichier trop volumineux. La taille maximale est de 10 Mo.",
        "uploadFailed": "Échec du téléchargement du CV. Veuillez réessayer."
      }
    }
  },
  "results": {
    "exportLabel": "Exporter",
    "exportCsv": "Exporter CSV",
    "csv": {
      "headers": {
        "candidateName": "Nom du candidat",
        "email": "E-mail",
        "role": "Rôle",
        "stage": "Étape",
        "overallScore": "Score global",
        "outcome": "Résultat",
        "eligibility": "Éligibilité",
        "expectations": "Attentes",
        "avgScore": "Score moyen",
        "interviewDate": "Date d'entretien",
        "status": "Statut"
      }
    },
    "emptyTitle": "Aucun résultat pour le moment",
    "emptyDescription": "Les entretiens terminés apparaîtront ici.",
    "columns": {
      "candidate": "Candidat",
      "stage": "Étape",
      "status": "Statut",
      "score": "Score",
      "outcome": "Résultat",
      "eligibility": "Éligibilité",
      "expectations": "Attentes",
      "avgScore": "Score moyen",
      "interviewDate": "Date d'entretien",
      "question": "Question"
    },
    "statusLabels": {
      "pending": "En attente",
      "processing": "En cours",
      "completed": "Terminé",
      "failed": "Échoué",
      "no_interview": "Pas d'entretien"
    },
    "questionSections": {
      "eligibility": "Éligibilité",
      "job_preview": "Attentes",
      "nice_to_have": "Atouts",
      "assessment": "Évaluation",
      "information": "Information"
    },
    "fields": {
      "reasoning": "Raisonnement",
      "evidence": "Preuves",
      "response": "Réponse",
      "avgScoreLabel": "Score moyen",
      "interviewDate": "Date d'entretien"
    }
  },
  "orgSettings": {
    "title": "Paramètres de l'organisation",
    "branding": {
      "title": "Image de marque",
      "logo": "Logo de l'organisation",
      "logoDescription": "Téléchargez un logo pour remplacer le logo Kiku par défaut dans la barre de navigation.",
      "uploadLogo": "Télécharger le logo",
      "removeLogo": "Supprimer le logo",
      "logoHint": "PNG, JPG, WebP ou SVG. Max 2 Mo.",
      "uploadSuccess": "Logo mis à jour avec succès",
      "removeSuccess": "Logo supprimé",
      "uploadError": "Échec du téléchargement du logo"
    },
    "timezone": {
      "title": "Fuseau horaire",
      "description": "Définissez le fuseau horaire par défaut pour la planification et l'affichage des dates.",
      "label": "Fuseau horaire",
      "saveSuccess": "Fuseau horaire mis à jour",
      "saveError": "Échec de la mise à jour du fuseau horaire"
    },
    "save": "Enregistrer les modifications"
  },
  "mcp": {
    "title": "Intégration MCP",
    "subtitle": "Connectez des assistants IA à Kiku via le Model Context Protocol",
    "whatIsMcp": "Qu'est-ce que MCP ?",
    "whatIsMcpDescription": "Le Model Context Protocol (MCP) permet aux assistants IA comme Claude, ChatGPT et d'autres outils d'interagir directement avec Kiku — lister les postes, consulter les candidats et gérer votre pipeline de recrutement en langage naturel.",
    "serverUrl": "URL du serveur",
    "copyUrl": "Copier l'URL",
    "copied": "Copié !",
    "availableTools": "Outils disponibles",
    "toolListJobs": "Rechercher et lister les offres d'emploi avec noms de département, filtres par statut, statut de configuration et département.",
    "toolGetJob": "Obtenir tous les détails d'une offre d'emploi spécifique, y compris le nom du département.",
    "toolCreateJob": "Créer une nouvelle offre d'emploi dans un département.",
    "toolAdvanceSetup": "Faire avancer un poste dans les étapes de configuration (brouillon, questions_pending, prêt, actif).",
    "toolListApplications": "Lister les candidatures pour un emploi avec noms d'étape, statut de notation et résultat.",
    "toolGetInterviewResults": "Obtenir les résultats d'entretien IA pour une candidature — score, résultat et détail par question avec raisonnement.",
    "toolGetPipelineSummary": "Obtenir un résumé du pipeline pour un emploi — nombre de candidats par étape avec totaux acceptés/refusés.",
    "setupTitle": "Configuration avec Claude Desktop",
    "setupStep1": "Ouvrez Claude Desktop",
    "setupStep2": "Cliquez sur Customize dans la barre latérale gauche",
    "setupStep3": "Cliquez sur Connectors, puis l'icône +, puis Add custom connector",
    "setupStep4": "Entrez Name : Kiku et l'URL du serveur affichée ci-dessus",
    "setupStep5": "Cliquez sur Add — Claude peut maintenant utiliser vos données Kiku"
  }
}
